import { useCallback } from 'react';

import { useAlignEvaluatorInfo } from '@/Pages/Playground/PlaygroundHome/hooks/useAlignEvaluator';
import {
  UseSWRMutationOptions,
  useSessionUpdateMutationTemplateParam,
  useUser,
} from '@/hooks/useSwr';
import { PatchSessionBody, SessionSchema } from '@/types/schema';

import { EVALUATOR_PLAYGROUND_BASELINE_SESSION_PROMPT_ID_METADATA_KEY } from '../constants';

export const useUpdateSessionPromptMetadata = ({
  options,
}: {
  options?: UseSWRMutationOptions<
    SessionSchema,
    PatchSessionBody,
    { sessionId: string }
  >;
}) => {
  const { trigger, isMutating } =
    useSessionUpdateMutationTemplateParam(options);
  const { isAlignEvaluatorV2 } = useAlignEvaluatorInfo();
  const user = useUser();
  const email = user?.data?.data.user?.email;

  const triggerUpdate = useCallback(
    async (promptId?: string, sessionId?: string) => {
      if (!sessionId || !promptId) {
        return;
      }
      await trigger({
        templateUrlParams: {
          sessionId,
        },
        json: {
          extra: {
            __ls_user_email: email,
            metadata: {
              [EVALUATOR_PLAYGROUND_BASELINE_SESSION_PROMPT_ID_METADATA_KEY]:
                promptId,
              __ls_runner: isAlignEvaluatorV2
                ? 'langsmith_align_evals'
                : 'langsmith_ui',
            },
          },
        },
      });
    },
    [trigger]
  );

  return { trigger: triggerUpdate, isMutating };
};
